import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { InternalPageReference } from '../../schema/datocms';
import { ComponentTypeNames } from '../../schema';

export interface LinkProps {
    externalPageUrl?: string;
    internalPageReference?: InternalPageReference;
    internalPageSectionId?: string;
    additionalOnClickActions?: () => void;
}

const setReferralPath = (): void => {
    window.sessionStorage.setItem('quoteReferralUrl', window.location.href);
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const Link = ({ children, externalPageUrl, internalPageReference, internalPageSectionId, additionalOnClickActions = () => {}, ...rest }: React.PropsWithChildren<LinkProps> & React.HTMLAttributes<Element> ): React.ReactElement | null => {

    if (externalPageUrl) {
        return <a href={externalPageUrl} rel="noopener noreferrer" target="_blank" {...rest}>{children}</a>;
    } else if (internalPageReference) {
        let pagePath: string = internalPageReference.slug || '';
        if (internalPageReference.__typename === ComponentTypeNames.BLOG_POST) {
            pagePath = `blog/${internalPageReference.slug}`;
        } else if (pagePath.toLowerCase() === 'homepage') {
            pagePath = '';
        }

        // Add a / to the end of pagePath if one is not there
        if (pagePath !== (null || undefined) && pagePath.length > 0) {
            const splitPagePath: string[] = pagePath.split('');
            const lastIndex: number = splitPagePath.length - 1;

            if (splitPagePath[lastIndex] !== '/') {
                pagePath = `${pagePath}/`;
            }
        }

        let internalPath: string;
        if ( internalPageSectionId && pagePath.length === 0) {
            // links to component on the homepage
            internalPath = `#${internalPageSectionId}`;
        } else {
            internalPath = internalPageSectionId ? `${pagePath}#${internalPageSectionId}` : pagePath;
        }

        if (internalPageSectionId === 'quote_form') {
            return <GatsbyLink to={`/${ internalPath }`} {...rest} onClick={(e) => {
                setReferralPath();
                additionalOnClickActions();
            }}>{children}</GatsbyLink>;
        }

        return <GatsbyLink to={`/${ internalPath }`} {...rest}>{children}</GatsbyLink>;
    } else if (internalPageSectionId) {
        return <GatsbyLink to={`#${internalPageSectionId}`} {...rest}>{children}</GatsbyLink>;
    } else {
        return null;
    }
};

export default Link;
